export default __webpack_public_path__ + "static/media/chillrx_showcase_1.webp";